// Config
import IPC from "components/Stacker/config/ImagePresetsConfig"

export function getPresetSuffix(cropQuadrant, presetkey) {
  let imagePreset = ""
  if (cropQuadrant) {
    imagePreset = `.jpg${cropQuadrant}`
  }
  return imagePreset
}
